import { Pipe, PipeTransform } from '@angular/core'
import { AccountUser } from '@app/domain/AccountUser'
import { Business } from '@app/domain/Business'
import { Organisation } from '@app/domain/Organisation'
import { Venue } from '@app/domain/Venue'

@Pipe({
    name: 'userVenueNames',
})
export class UserVenueNamesPipe implements PipeTransform {

    transform(user: AccountUser, organisation: Organisation): string {
        const venueIds = user.venueIds
        if (venueIds === null) {
            return 'All venues'
        }
        if (venueIds.length === 0) {
            return 'No venues'
        }
        return organisation.businesses
            .flatMap((business: Business) => business.venues)
            .filter((venue: Venue) => venueIds.includes(venue.id))
            .map((venue: Venue) => venue.displayName)
            .join(', ')
    }
}
